module.exports = __webpack_public_path__ + "img/logo.8ae9b4c4.png";